import {injectIntl} from 'react-intl';
import React from 'react';
import connect from "react-redux/es/connect/connect";
import FormComponent from "./forms/ChangePasswordForm";
import styles from './css/ProfileDetails.scss';
import {createSubmitAction} from "../../app/forms";
import {UPDATE_PASSWORD, UPDATE_PASSWORD_FAILURE, UPDATE_PASSWORD_SUCCESS} from "../settings";
import {FormattedMessage} from "react-intl";
import Button from "../../../ui/Button";

@injectIntl
export class ChangePassword extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            successful: false,
            visible: false,
        }
    }

    render() {
        const { visible, successful } = this.state;

        if (successful) {
            return (
                <div className={styles.profile}>
                    <FormattedMessage id='frontend.profile.change_password.success' />
                </div>
            );
        }

        if (!visible) {
            return (
                <div className={styles.profile}>
                    <Button emphasis='default' onClick={() => this.setState({visible: true})}>
                        <FormattedMessage id='frontend.profile.change_password.title' />
                    </Button>
                </div>
            )
        }

        return (
            <div className={styles.profile}>
                <FormComponent
                    onSubmitSuccess={() => this.handleSuccess()}
                    onSubmit={createSubmitAction(
                        UPDATE_PASSWORD,
                        UPDATE_PASSWORD_SUCCESS,
                        UPDATE_PASSWORD_FAILURE,
                    )}/>
            </div>
        );
    }

    handleSuccess() {
        this.setState({
            successful: true,
            visible: false,
        });
    }
}

export default connect(() => ({}))(ChangePassword);
